<template>
    <div class="useMedicine-container">
        <div class="sect-container">
            <div  class="head-container">
                <p class="title">{{$t("useMedicine.title")}}</p>
                <p class="desc">{{$t("useMedicine.titleDesc")}}</p>
            </div>
            <div class="selectOption-container">
                <div class="option-item flexC" v-for="(item,index) in options" :key="index" @click="goPage(item)">
                    <p class="name">
                        {{item.text}}
                    </p>
                    <van-icon name="arrow" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            options:[
                {text:"我已购药",type:1},
                {text:"用药有调整",type:2},
                {text:"已经停药",type:3}
            ]
        }
    },
    created () {
        document.title = this.$t("useMedicine.name")  
    },
    methods: {
        goPage(item){
            let query = this.$route.query;
            query.type = item.type;
            this.$router.push({
                path:"/useMedicine/details",
                query:query
            })
        }
    }
}
</script>
<style lang="less" scoped>
.useMedicine-container{
    padding: 0 0.6rem;
    background: linear-gradient(360deg, #F2FBFF 0%, #76BDFF 100%);
    .sect-container{
        height: 100vh;
        width: 100%;
        overflow: auto;
        background: url("~@/assets/img/useMedicine-bg.png") no-repeat;
        // background-image: ;
        background-size: 5.08rem 4.2rem;
        background-position: top right;
        // background-position-x: /;
        background-repeat: no-repeat;
        .head-container{
            overflow: auto;
            margin-bottom: 0.8rem;
            .title{
                font-size: 0.96rem;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                margin: 1rem 0 0.2rem 0;
                color: #FFFFFF;
                line-height: 1.34rem;
                text-shadow: 0 0.04rem 0.08rem #2379FF;
            }
            .desc{
                position: relative;
                padding-left: 0.7rem;
                font-size: 0.56rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 0.8rem;
                &::after{
                    width: 0.38rem;
                    content: ' ';
                    height: .48rem;
                    background: url("~@/assets/img/useMedicine-icon.png") no-repeat;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translate(0,-50%);
                }
            }
        }
        .selectOption-container{
            .option-item{
                
                padding: 0 0.7rem;
                margin-bottom: 0.72rem;
                height: 2.16rem;
                background: linear-gradient(180deg, #EBF7FF 0%, #FFFFFF 100%);
                border-radius: 0.24rem;
                border: 0.04rem solid #FFFFFF;
                .name{
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    font-size: 0.72rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    flex: 1;
                    color: #303133;
                }
                .van-icon-arrow{
                    flex: 0 0 auto;
                    margin-left: 0.2rem;
                    font-size: 0.6rem;
                }
            }
        }
    }

}
</style>